import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE as API } from "@/config";

const rs = (p) => `₹${((p || 0) / 100).toFixed(2).replace(/\.00$/, "")}`;

// Read-only audit trail of commission corrections
export const CorrectionsTable = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/affiliate/corrections`).then(r => setRows(r.data.corrections || [])).catch(() => setRows([]));
  }, []);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-testid="aff-corrections-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50/50">
              {["Date", "Influencer", "Payment ID", "Order ID", "Order", "Commission", "Change", "Reason"].map(h => (
                <th key={h} className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((a, i) => (
              <tr key={a.audit_id} className="border-b border-gray-50 align-top" data-testid={`aff-correction-row-${i}`}>
                <td className="px-3 py-2.5 text-xs text-gray-500 whitespace-nowrap">{new Date(a.created_at).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                <td className="px-3 py-2.5 text-xs font-semibold text-gray-900 whitespace-nowrap">{a.influencer_name} <code className="ml-1 bg-gray-100 text-amber-700 px-1.5 py-0.5 rounded text-[10px] font-bold">{a.ref_code}</code></td>
                <td className="px-3 py-2.5 text-[11px] font-mono text-gray-600">{a.payment_id}</td>
                <td className="px-3 py-2.5 text-[11px] font-mono text-gray-600">{a.order_id}</td>
                <td className="px-3 py-2.5 text-xs text-gray-600 tabular-nums">{rs(a.order_amount)}</td>
                <td className="px-3 py-2.5 text-xs font-bold text-gray-900 tabular-nums">{rs(a.commission_amount)}</td>
                <td className="px-3 py-2.5 text-[10px] font-bold uppercase text-red-600 whitespace-nowrap">{a.previous_status} → {a.new_status}</td>
                <td className="px-3 py-2.5 text-xs text-gray-500 min-w-[220px]">{a.reason}</td>
              </tr>
            ))}
            {rows && rows.length === 0 && (
              <tr><td colSpan={8} className="text-center text-gray-400 py-8 text-sm">No corrections recorded</td></tr>
            )}
            {!rows && (
              <tr><td colSpan={8} className="text-center text-gray-400 py-8 text-sm">Loading...</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
